import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getAction } from "@api/manage";
import { filterObj } from '@/utils/util';
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
export default {
  name: "StockLogModal",
  mixins: [JeecgListMixin],
  components: {},
  data: function data() {
    return {
      title: '出入库记录',
      visible: false,
      dataSource: [],
      selectionRows: [],
      queryParam: {},
      ipagination: {
        current: 1,
        pageSize: 5,
        pageSizeOptions: ['5', '10', '20'],
        showTotal: function showTotal(total, range) {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      isorter: {
        column: 'createTime',
        order: 'desc'
      },
      url: {
        queryStockLog: "/stock/log"
      },
      productCategorys: "",
      productId: "",
      // 表头
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: "center",
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'siteName',
        colName: 'site_id',
        title: '出库站点ID',
        align: "center"
      }, {
        dataIndex: 'category_dictText',
        colName: 'category',
        title: '出入库类型',
        align: "center"
      }, {
        dataIndex: 'dtime',
        colName: 'dtime',
        title: '出入库时间',
        align: "center"
      }, // {
      //   dataIndex: 'companyName',
      //   colName: 'supplier_id',
      //   title: '供应商ID',
      //   align: "center",
      // },
      // {
      //   dataIndex: 'productId',
      //   colName: 'product_id',
      //   title: '产品ID',
      //   align: "center",
      // },
      {
        dataIndex: 'amount',
        colName: 'amount',
        title: '出入库数量',
        align: "center"
      }, {
        dataIndex: 'price',
        colName: 'price',
        title: '产品单价',
        align: "center"
      }, {
        dataIndex: 'worth',
        colName: 'worth',
        title: '出入库金额',
        align: "center"
      }, {
        dataIndex: 'remark',
        colName: 'remark',
        title: '备注',
        align: "center"
      }]
    };
  },
  created: function created() {},
  computed: {},
  methods: {
    /**
     * 时间筛选
     * @param value
     * @param dtime
     */
    onDateSdata: function onDateSdata(value, dtime) {
      this.queryParam.stockDate = dtime;
    },
    add: function add(productId) {
      this.productId = productId;
      this.visible = true;
      this.dataSource = [], this.loadData();
    },
    loadData: function loadData(arg) {
      var _this = this;

      if (arg === 1) {
        this.ipagination.current = 1;
      }

      this.queryParam.productId = this.productId;
      var params = this.getQueryParams(); //查询条件

      getAction(this.url.queryStockLog, params).then(function (res) {
        if (res.success) {
          _this.dataSource = res.result.records;
          _this.ipagination.total = res.result.total;
        }
      });
    },
    handleOk: function handleOk() {
      this.$emit('choseStockLog', this.selectionRows);
      this.handleCancel();
    },
    handleCancel: function handleCancel() {
      this.selectionRows = [];
      this.visible = false;
    },
    searchByquery: function searchByquery() {
      this.loadData(1);
    },
    searchReset: function searchReset() {
      var that = this;
      Object.keys(that.queryParam).forEach(function (key) {
        that.queryParam[key] = '';
      });
      that.loadData(1);
    },
    getQueryParams: function getQueryParams() {
      var param = Object.assign({}, this.queryParam);
      param.field = this.getQueryField();
      param.pageNo = this.ipagination.current;
      param.pageSize = this.ipagination.pageSize;
      return filterObj(param);
    },
    getQueryField: function getQueryField() {
      var str = "id,";

      for (var a = 0; a < this.columns.length; a++) {
        str += "," + this.columns[a].dataIndex;
      }

      return str;
    },
    handleTableChange: function handleTableChange(pagination, filters, sorter) {
      //TODO 筛选
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field;
        this.isorter.order = "ascend" == sorter.order ? "asc" : "desc";
      }

      this.ipagination = pagination;
      this.loadData();
    }
  }
};